(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["blog"]) return;
  try {
    
    $(document).ready(function ()
    {
    PROJ.blog.init();
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-back"]) return;
  try {
    

    $(function () {
    PROJ.collection.init();
    });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["com-hero-imagevideo"] && !window.DesignMode) return;
  try {
    

    $(document).ready(function ()
    {
    PROJ.hero.init();
    })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact"] && !window.DesignMode) return;
  try {
    
    $(document).ready(function ()
    {
        PROJ.contact.init();
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-gift"]) return;
  try {
    

    $(function () {
    PROJ.products.init();
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-old"]) return;
  try {
    

    $(function () {
    PROJ.products.init();
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    

    $(function () {
    PROJ.products.init();
    });


  } catch(e) { console.error(e); }
})();

})();
